import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PageableResponse } from '@pwc-bei/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { Service } from 'src/app/models/coe/service';
import { ServiceRequest } from 'src/app/models/coe/service-request';
import { Tag } from 'src/app/models/tag';
import { validateId, validateUrl } from 'src/app/utils/utils';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ThematicAreaServiceService {
  // protected baseUrl: string = 'http://localhost:8112';
  protected baseUrl: string = environment.apiUrl;
  // accorpamento esg-request
  protected endpointService: string = '/tls-fa-request/service/';
  protected endpointServiceRequest: string = '/tls-fa-request/serviceRequest/';
  protected tagEndpoint: string = '/tls-fa-request/tag/';

  public pagination: PageableResponse<Service[]> = {
    pageable: {
      pageNumber: 0,
      pageSize: 10,
      offset: 0,
      sort: '',
    },
    number: null,
    size: null,
    totalElements: null,
    numberOfElements: null,
    content: null,
  };

  constructor(private httpClient: HttpClient, private sanitizer: DomSanitizer,) { }

  findAll(
    filter: Partial<Service> = null,
    tags?: string[],
    ids?: string[],
    sort?: string,
    page?: number,
    pageSize?: number,
    searchTerm?: string,
    terms?: string[],
    pathVariables?: Map<string, string>,
  ): Observable<PageableResponse<Service[]>> {
    let params: HttpParams = new HttpParams();

    // Pagination: if present update the saved pagination; use the saved pagination otherwise
    if (page != undefined) {
      this.pagination.pageable.pageNumber = page;
      params = params.append('page', page.toString());
    } else {
      params = params.append(
        'page',
        this.pagination.pageable.pageNumber
          ? this.pagination.pageable.pageNumber.toString()
          : '0',
      );
    }

    if (pageSize) {
      this.pagination.pageable.pageSize = pageSize;
      params = params.append('size', pageSize.toString());
    } else {
      params = params.append(
        'size',
        this.pagination.pageable.pageSize
          ? this.pagination.pageable.pageSize.toString()
          : '10',
      );
    }

    params = params.append('sort', 'pinned,desc');
    if (sort && sort !== '') {
      this.pagination.pageable.sort = sort;
      params = params.append('sort', sort);
    } else {
      this.pagination.pageable.sort = 'createdDate,desc';
      params = params.append('sort', 'createdDate,desc');
    }
    params = params.append('isPaged', 'true');

    // SerchTerm
    if (searchTerm && searchTerm !== '') {
      params = params.append('searchTerm', searchTerm);
      terms.forEach((term) => {
        params = params.append('terms', term);
      });
    }

    // Filters
    if (tags) {
      tags.forEach((t) => {
        params = params.append('tags', t);
      });
    }
    if (ids) {
      ids.forEach((id) => {
        params = params.append('id', id);
      });
    }

    if (filter) {
      if (filter.title) {
        params = params.append('title', filter.title);
      }
      if (filter.area) {
        params = params.append('area', filter.area);

        if (filter.pinned) {
          params = params.append('pinnedForArea', filter.area)
        }  
      }
      if (filter.status) {
        params = params.append('status', filter.status);
      }
      if (filter.visible !== null && filter.visible !== undefined) {
        params = params.append('visible', filter.visible ? 'true' : 'false');
      }
      if (filter.isAssessment !== null && filter.isAssessment !== undefined) {
        params = params.append('isAssessment', filter.isAssessment ? 'true' : 'false')
      }
    }
    params = params.append('withImg', 'true');
    // Execute the API call and return the body of the response
    return this.httpClient
      .get<PageableResponse<Service[]>>(
        this.baseUrl +
        this.endpointService +
        (pathVariables ? pathVariables : ''),
        {
          params,
          observe: 'response',
        },
      )
      .pipe(map((res) => res.body))
      .pipe(
        map((res) => {
          this.pagination.totalElements = res.totalElements;
          this.pagination.number = res.number;
          this.pagination.size = res.size;
          this.pagination.numberOfElements = res.numberOfElements;
          this.pagination.pageable = res.pageable;
          return res;
        }),
      );
  }

  detail(serviceId: string): Observable<Service> {
    const uri: string = validateUrl(this.baseUrl + this.endpointService + encodeURIComponent(validateId(serviceId)) + '/');
    
    return this.httpClient
      .get<Service>(encodeURI(this.sanitizer.sanitize(SecurityContext.URL, uri)), {
        observe: 'response',
      })
      .pipe(
        map((res) => {
          return res.body;
        }),
      );
  }

  insertRequest(serviceRequest: ServiceRequest): Observable<any> {
    return this.httpClient
      .post(this.baseUrl + this.endpointServiceRequest + "b2c/", serviceRequest);
  }

  sendOpenEmail(serviceRequestId: String): Observable<any> {
    return this.httpClient
      .get(this.baseUrl + this.endpointServiceRequest + 'sendMailOpenService/' + serviceRequestId + '/');
  }

  getTags(): Observable<Tag[]> {
    let params: HttpParams = new HttpParams();
    params = params.append('isPaged', 'false');

    return this.httpClient
      .get<Tag[]>(this.baseUrl + this.tagEndpoint, {
        params,
        observe: 'response',
      })
      .pipe(
        map((res) => {
          return res.body;
        }),
      );
  }

  findAllNotPaged(
    filter: Partial<Service> = null,
    pathVariables?: Map<string, string>,
  ): Observable<Service[]> {
    let params: HttpParams = new HttpParams();
    params = params.append('isPaged', 'false');

    if (filter) {
      if (filter.area) {
        params = params.append('area', filter.area);
      }
      if (filter.status) {
        params = params.append('status', filter.status);
      }
      if (filter.visible !== null && filter.visible !== undefined) {
        params = params.append('visible', filter.visible ? 'true' : 'false');
      }
      if (filter.isAssessment !== null && filter.isAssessment !== undefined) {
        params = params.append(
          'isAssessment',
          filter.isAssessment ? 'true' : 'false',
        );
      }
    }

    // Execute the API call and return the body of the response
    return this.httpClient
      .get<Service[]>(
        this.baseUrl +
        this.endpointService +
        (pathVariables ? pathVariables : ''),
        {
          params,
          observe: 'response',
        },
      )
      .pipe(map((res) => res.body))
      .pipe(
        map((res) => {
          return res;
        }),
      );
  }

  getOpenServiceRequestForCustomerAndServiceId(customerID: string, serviceID: string, societyId: number) {
    // Execute the API call and return the body of the response
    return this.httpClient
      .get<string>(this.baseUrl + this.endpointServiceRequest + `open/customer/${customerID}/service/${serviceID}/society/${societyId}`, {
        observe: 'response'
      })
      .pipe(map(res => res.body))
      .pipe(map(res => {
        return res;
      }));
  }
}
